<template>
  <div class="app-container">
    <TopBar class="top-bar" title="累计消费鲸币" color="#fff"></TopBar>
    <div class="container">
      <div class="header-background">
        <p>累计消费鲸币(个)</p>
        <div class="header-number">{{userCoinInfo.consume_coin}}</div>
      </div>
      <datepicker @dateChange="dateChange" class="date-picker"></datepicker>
      <!--消费记录-->
      <load-more ref="loadMore" :loadmore="fetchData" :list="list" class="load-box">
        <template v-slot:default>
          <div class="consumption-con">
            <consumption-item v-for="item in list" :key="item.id" :item="item"></consumption-item>
          </div>
        </template>
        <template v-slot:noDataTip>
          <p>本月无消费记录</p>
        </template>
      </load-more>
    </div>
  </div>
</template>

<script>
import datepicker from '@/components/Datepicker'
import TopBar from '@/components/TopBar'
import consumptionItem from './components/consumptionItem'
import LoadMore from 'components/LoadMore'
import { bridge } from 'mixins'
import { switchNavigationBar } from '@/utils/utils'
import userCoinInfoMixin from './userCoinInfoMixin'
import { getUserCoinReward } from '@/api/fundsManage'
export default {
  name: "consumptionRecords",
  components: {
    datepicker,
    consumptionItem,
    LoadMore,
    TopBar
  },
  mixins: [bridge, userCoinInfoMixin],
  data() {
    return {
      list: [],
      newDate: null,
      coverData: false // 用于刷新数据覆盖，防止数据抖动
    }
  },
  computed: {
    curDate() {
      const date = this.newDate || new Date()
      let month = new Date(date).getMonth() + 1
      return `${new Date(date).getFullYear()}-${month < 10 ? '0' + month : month}`
    }
  },
  mounted() {
    switchNavigationBar(1)
    this.getUserCoinInfo()
    this.setNavTitle('消费记录')
    const myBridge = this.getBridge()
    myBridge.call('isPullRefreshEnable', {
      enable: 0
    })
  },
  methods: {
    fetchData($event) {
      return new Promise(resolve => {
        getUserCoinReward($event.pageNo, $event.pageSize, this.curDate)
          .then(res => {
            this.setList(res)
            resolve(res.data.data)
          })
      })
    },
    setList (res) {
      if (+res.data.code === 0) {
        if (this.coverData) {
          this.coverData = false
          this.list = res.data.data
        } else {
          this.list = this.list.concat(res.data.data)
        }
      }
    },
    dateChange(val) {
      this.newDate = val
      this.coverData = true
      this.$refs.loadMore.reset()
    }
  }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
.top-bar {
  background: #6982fa;
  /deep/ .fixed {
    background: #6982fa;
  }
}
.container {
  padding: 0;
  .header-background {
    background: url('../../assets/images/record-header.png') no-repeat bottom;
    background-size: cover;
    text-align: center;
    color: #FFFFFF;
    height: 400px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 40px;
    p {
      font-family: PingFangSC-Regular;
      font-size: 26px;
      margin-bottom: 30px;
    }
  }
  .date-picker {
    padding: 30px 0 0 30px;
  }
  .load-box {
    padding: 30px 30px 0;
    flex: 1;
    .item:not(:last-child) {
      margin-bottom: 30px;
    }
    /deep/ .no-data {
      height: 100%;
      min-height: auto;
      box-sizing: border-box;
    }
  }
}
</style>
